export enum LOCAL_STORAGE_KEYS {
  ADMIN_AUTH_TOKEN_EXPIRES_AT = 'admin_auth_token_expires_at',
  ADMIN_AUTH_TOKEN_JWT = 'admin_auth_token',
  AUTH_TOKEN_EXPIRES_AT = 'auth_token_expires_at',
  AUTH_TOKEN_JWT = 'auth_token',
}

export class LocalStorage {
  getItem(key: LOCAL_STORAGE_KEYS) {
    return localStorage.getItem(key);
  }

  setItem(key: LOCAL_STORAGE_KEYS, value: string) {
    localStorage.setItem(key, value);
  }

  removeItem(key: LOCAL_STORAGE_KEYS) {
    localStorage.removeItem(key);
  }
}

export const LocalStorageInstance = new LocalStorage();
